import { useSearchParams } from "react-router-dom";
import NacidRecognitionView from "./NacidRecognitionView";
import { ACADEMIC_RECOGNITION_TYPE } from "../../../../../config/registers/common";
import UniversityRecognitionView from "./UniversityRecognitionView";

const AcademicRecognitionView = () => {
  const [searchParams] = useSearchParams();
  const recognitionType = searchParams.get("type");

  switch (recognitionType) {
    case ACADEMIC_RECOGNITION_TYPE.NACID:
      return <NacidRecognitionView />;
    case ACADEMIC_RECOGNITION_TYPE.UNIVERSITIES:
      return <UniversityRecognitionView />;
  }
};

export default AcademicRecognitionView;
